/**
 * Branding style selector component
 */

import { Sparkles, Globe } from "lucide-react";

export function BrandingSelector({ 
  postStyle, 
  setPostStyle, 
  brandingStyle, 
  setBrandingStyle,
  hasBrandAssets,
  user 
}) {
  return (
    <div className="card-base p-6">
      <label className="text-sm text-viraly-muted mb-3 block">Post Style</label>
      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => setPostStyle("generic")}
          data-testid="style-generic"
          className={`p-4 rounded-xl border-2 transition-all ${
            postStyle === "generic"
              ? "border-viraly-orange bg-viraly-orange/10"
              : "border-white/10 hover:border-white/20"
          }`}
        >
          <Sparkles className="w-5 h-5 mb-2" />
          <p className="font-medium">Generic</p>
          <p className="text-xs text-viraly-muted">Standard AI style</p>
        </button>
        <button
          onClick={() => setPostStyle("my_brand")}
          disabled={!hasBrandAssets}
          data-testid="style-mybrand"
          className={`p-4 rounded-xl border-2 transition-all ${
            postStyle === "my_brand"
              ? "border-viraly-orange bg-viraly-orange/10"
              : !hasBrandAssets
                ? "border-white/5 opacity-50 cursor-not-allowed"
                : "border-white/10 hover:border-white/20"
          }`}
        >
          <Globe className="w-5 h-5 mb-2" />
          <p className="font-medium">Personal Brand</p>
          <p className="text-xs text-viraly-muted">
            {hasBrandAssets ? "Your branding overlay" : "Set up in Settings"}
          </p>
        </button>
      </div>
      
      {/* Branding Style Selection */}
      {postStyle === "my_brand" && hasBrandAssets && (
        <div className="mt-4 space-y-3">
          <label className="text-sm text-viraly-muted block">Branding Intensity</label>
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => setBrandingStyle("subtle")}
              data-testid="branding-subtle"
              className={`p-3 rounded-xl border-2 transition-all text-left ${
                brandingStyle === "subtle"
                  ? "border-viraly-orange bg-viraly-orange/10"
                  : "border-white/10 hover:border-white/20"
              }`}
            >
              <p className="font-medium text-sm">Subtle</p>
              <p className="text-xs text-viraly-muted">Small logo/watermark</p>
            </button>
            <button
              onClick={() => setBrandingStyle("prominent")}
              data-testid="branding-prominent"
              className={`p-3 rounded-xl border-2 transition-all text-left ${
                brandingStyle === "prominent"
                  ? "border-viraly-orange bg-viraly-orange/10"
                  : "border-white/10 hover:border-white/20"
              }`}
            >
              <p className="font-medium text-sm">Prominent</p>
              <p className="text-xs text-viraly-muted">Full footer with contact</p>
            </button>
          </div>
          
          {/* Brand Picture Selection */}
          {(user?.headshot_url || user?.logo_url) && (
            <div className="mt-3">
              <label className="text-xs text-viraly-muted block mb-2">Brand Picture</label>
              <div className="flex gap-2">
                {user?.headshot_url && (
                  <img
                    src={user.headshot_url}
                    alt="Headshot"
                    className="w-12 h-12 rounded-full object-cover cursor-pointer border-2 border-transparent hover:border-viraly-orange"
                    onClick={() => {}}
                  />
                )}
                {user?.logo_url && (
                  <img
                    src={user.logo_url}
                    alt="Logo"
                    className="w-12 h-12 rounded object-contain bg-white/10 cursor-pointer border-2 border-transparent hover:border-viraly-orange"
                    onClick={() => {}}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
